export const fKey = {
API_KEY: "AIzaSyDr7FQ1ZB99JyB_UOmqCAnzeO2UixpCgLE",
AUTH_DOMAIN: "gitgoing-51f28.firebaseapp.com",
DATABASE_URL: "https://gitgoing-51f28.firebaseio.com",
PROJECT_ID: "gitgoing-51f28",
STORAGE_BUCKET: "gitgoing-51f28.appspot.com",
MESSAGING_SENDER_ID: "690526517251"
}